import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Login } from './auth/login.tsx';

function App() {
  return (
    <div >
      <Routes>
          <Route path='/' element={<Login/>}/>
          <Route path='/perfil'/>
          <Route path='/administrador' />
      </Routes>
    </div>
  );
}

export default App;
